import { fetchAllThreadsFromClient } from './fetchAllThreads';

// Prefetch and CRM must never populate the same cache with different completeness guarantees.
export const clientThreadsQueryOptions = (clientId) => ({
  queryKey: ['threads', clientId],
  queryFn: ({ signal }) => fetchAllThreadsFromClient(clientId, { signal }),
});
